import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import sha256 from "js-sha256";
import { getCountryLabel, getGender, getSign } from "../services/functions";

export default function Sidebar(props) {
  const homeLink = "/" + (props.searchterm ? props.searchterm : "");
  const orderLink = "/orders/" + (props.searchterm ? props.searchterm : "");
  const customerLink =
    "/customers/" + (props.searchterm ? props.searchterm : "");
  const creditLink = "/credits/" + (props.searchterm ? props.searchterm : "");
  const notesLink = "/notes/" + (props.searchterm ? props.searchterm : "");
  const prodPermissionLink =
    "/productpermission/" + (props.searchterm ? props.searchterm : "");
  const maropostLink =
    "/maropost/" + (props.searchterm ? props.searchterm : "");
  const reportLink = "/reports/" + (props.searchterm ? props.searchterm : "");
  const memberlogsLink =
    "/memberloginlogs/" + (props.searchterm ? props.searchterm : "");
  const servicesLink =
    "/services/" + (props.searchterm ? props.searchterm : "");

  const currentUser = useSelector((state) => state.currentUser);
  const currentCustomer = useSelector((state) => state.currentCustomer);

  let memberLink = "";

  if (props.searchterm) {
    const hash = sha256(props.searchterm);
    memberLink = `https://members.astrologyanswers.com/create-account.php?hash=${hash}`;
  }

  return (
    <>
      <div id="app-sidepanel" className="app-sidepanel sidepanel-visible">
        <div id="sidepanel-drop" className="sidepanel-drop"></div>
        <div className="sidepanel-inner d-flex flex-column">
          <Link id="sidepanel-close" className="sidepanel-close d-xl-none">
            ×
          </Link>
          <div className="app-branding">
            <span className="logo-text">Astrology Answers</span>
          </div>
          <nav id="app-nav-main" className="app-nav app-nav-main">
            <ul
              className="app-menu list-unstyled accordion"
              id="menu-accordion"
            >
              <li className="nav-item">
                <Link className="nav-link" to={homeLink}>
                  <span className="nav-icon">
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                      className="bi bi-house-door"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.646 1.146a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5H9.5a.5.5 0 0 1-.5-.5v-4H7v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6zM2.5 7.707V14H6v-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4h3.5V7.707L8 2.207l-5.5 5.5z"
                      />
                      <path
                        fillRule="evenodd"
                        d="M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                      />
                    </svg>
                  </span>
                  <span className="nav-link-text">Welcome</span>
                </Link>
              </li>
              {props.searchterm && (
                <li className="nav-item">
                  <Link className="nav-link" to={customerLink}>
                    <span className="nav-icon">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        className="bi bi-files"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6 5c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                        />
                      </svg>
                    </span>

                    <span className="nav-link-text">Lead / Customer</span>
                  </Link>
                </li>
              )}
              {currentUser.user && (
                <li className="nav-item">
                  <Link className="nav-link" to={maropostLink}>
                    <span className="nav-icon">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        className="bi bi-receipt"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"
                        ></path>
                        <path
                          fillRule="evenodd"
                          d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                        ></path>
                      </svg>
                    </span>
                    <span className="nav-link-text">Maropost</span>
                  </Link>
                </li>
              )}
              {currentCustomer.user && (
                <li className="nav-item">
                  <Link className="nav-link" to={prodPermissionLink}>
                    <span className="nav-icon">
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-person-check"
                        viewBox="0 0 16 16"
                      >
                        <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"></path>
                      </svg>
                    </span>
                    <span className="nav-link-text">Products Permission</span>
                  </Link>
                </li>
              )}
              {currentCustomer.user && (
                <li className="nav-item has-submenu">
                  <Link
                    className="nav-link submenu-toggle"
                    data-bs-toggle="collapse"
                    data-bs-target="#submenu-1"
                    aria-expanded="true"
                    aria-controls="submenu-1"
                  >
                    <span className="nav-icon">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        className="bi bi-files"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4 2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
                        />
                        <path d="M6 0h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1H4a2 2 0 0 1 2-2z" />
                      </svg>
                    </span>
                    <span className="nav-link-text">Purchase Section</span>
                    <span className="submenu-arrow">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        className="bi bi-chevron-down"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </span>
                  </Link>
                  <div
                    id="submenu-1"
                    className="collapse submenu submenu-1 show"
                    data-bs-parent="#menu-accordion"
                  >
                    <ul className="submenu-list list-unstyled">
                      <li className="submenu-item">
                        <Link className="submenu-link" to={orderLink}>
                          Orders
                        </Link>
                      </li>
                      <li className="submenu-item">
                        <Link className="submenu-link" to={creditLink}>
                          Credits
                        </Link>
                      </li>
                      <li className="submenu-item">
                        <Link className="submenu-link" to={notesLink}>
                          Notes
                        </Link>
                      </li>
                      <li className="submenu-item">
                        <Link className="submenu-link" to={reportLink}>
                          Reports
                        </Link>
                      </li>
                      <li className="submenu-item">
                        <Link className="submenu-link" to={memberlogsLink}>
                          Member Login Logs
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
              <li className="nav-item">
                <Link className="nav-link" to={servicesLink}>
                  <span className="nav-icon">
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                      className="bi bi-tools"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M0 1l1-1 3.081 2.2a1 1 0 0 1 .419.815v.07a1 1 0 0 0 .293.708L10.5 9.5l.914-.305a1 1 0 0 1 1.023.242l3.356 3.356a1 1 0 0 1 0 1.414l-1.586 1.586a1 1 0 0 1-1.414 0l-3.356-3.356a1 1 0 0 1-.242-1.023L9.5 10.5 3.793 4.793a1 1 0 0 0-.707-.293h-.071a1 1 0 0 1-.814-.419L0 1zm11.354 9.646a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .708-.708l-3-3z"
                      />
                      <path
                        fillRule="evenodd"
                        d="M15.898 2.223a3.003 3.003 0 0 1-3.679 3.674L5.878 12.15a3 3 0 1 1-2.027-2.027l6.252-6.341A3 3 0 0 1 13.778.1l-2.142 2.142L12 4l1.757.364 2.141-2.141zm-13.37 9.019L3.001 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"
                      />
                    </svg>
                  </span>
                  <span className="nav-link-text">Services</span>
                </Link>
              </li>
            </ul>
          </nav>

          {currentCustomer.user && props.searchterm && (
            <>
              <div className="card mb-4 mt-4 bg-dark">
                <div className="card-body text-center">
                  <p className="text-white">
                    <strong>Customer Profile</strong>
                  </p>
                  <p className="text-white mb-0">
                    {currentCustomer.user.firstName}{" "}
                    {currentCustomer.user.lastName || ""}
                  </p>
                  <p className="text-white mb-0">
                    {currentCustomer.user.email}
                  </p>
                  <p className="text-white mb-0">
                    {currentCustomer.user.birthDay !== "0001-01-01"
                      ? new Date(
                          currentCustomer.user.birthDay
                        ).toLocaleDateString("en-US", {
                          month: "long",
                          day: "2-digit",
                          year: "numeric",
                          timeZone: "UTC",
                        })
                      : "No Date of Birth"}
                    &nbsp;|&nbsp;
                    {currentCustomer.user.birthTime}
                  </p>
                  <p className="text-white mb-0">
                    {currentCustomer.user.signId > 0
                      ? getSign(currentCustomer.user.signId)
                      : "No Sign"}
                    &nbsp;|&nbsp;
                    {currentCustomer.user.gender !== ""
                      ? getGender(currentCustomer.user.gender)
                      : "No Gender"}
                  </p>
                  <p className="text-white mb-0">
                    {currentCustomer.user.birthCountry
                      ? getCountryLabel(currentCustomer.user.birthCountry)
                      : "No Birth Country"}
                    ,&nbsp;
                    {currentCustomer.user.birthCity || "No Birth City"}
                  </p>
                </div>
              </div>
            </>
          )}
          {currentCustomer.user && currentUser.user && props.searchterm && (
            <>
              <div className="p-3 mb-2 bg-primary text-white text-center">
                <a
                  href={memberLink}
                  rel="noreferrer"
                  target="_blank"
                  className="link-light"
                >
                  Go To Members
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="bi bi-arrow-right ms-2"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    ></path>
                  </svg>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
